(() => {
  if (!window.IntersectionObserver) {
    return;
  }

  const intersectionThreshold = 0.9;
  const thresholdSteps = 100;
  const threshold = Array(thresholdSteps).fill('').map((entry, index) => index / thresholdSteps);
  const sliderRenderNavTimers = window.WeakMap ? new WeakMap() : new Map();
  const sliderApplyStopsTimers = window.WeakMap ? new WeakMap() : new Map();
  const sliderRenderDotNavTimers = window.WeakMap ? new WeakMap() : new Map();
  const sliderPreloadImageTimers = window.WeakMap ? new WeakMap() : new Map();
  const sliderAutoforwardTimers = window.WeakMap ? new WeakMap() : new Map();
  const sliderIntersectionRatiosMap = new Map();
  const itemIntersectionRatiosMap = window.WeakMap ? new WeakMap() : new Map();
  const imageObserverMap = window.WeakMap ? new WeakMap() : new Map();
  const itemObserverMap = window.WeakMap ? new WeakMap() : new Map();
  const sliderObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const slider = entry.target;
      const { intersectionRatio } = entry;

      sliderIntersectionRatiosMap.set(slider, intersectionRatio);
    });
  }, {
    rootMargin: '-15% -25% -25% -25%',
    threshold,
  });
  const renderNav = (slider) => {
    window.clearTimeout(sliderRenderNavTimers.get(slider));
    sliderRenderNavTimers.set(slider, window.setTimeout(() => {
      const itemIntersectionRatios = (itemIntersectionRatiosMap.get(slider) || [])
        .filter((entry) => entry.elem && (slider.getRootNode ? slider.getRootNode() : document.documentElement).contains(entry.elem));

      if (itemIntersectionRatios.length) {
        itemIntersectionRatios.forEach((entry, index) => {
          switch (index) {
            default:
              break;

            case 0:
              if (entry.intersectionRatio >= intersectionThreshold) {
                if (slider.classList.contains('swinger-slider--show-previous')) {
                  slider.classList.remove('swinger-slider--show-previous');
                }
              } else if (!slider.classList.contains('swinger-slider--show-previous')) {
                slider.classList.add('swinger-slider--show-previous');
              }
              // no break because of special case with few items

            // eslint-disable-next-line no-fallthrough
            case (itemIntersectionRatios.length - 1):
              if (entry.intersectionRatio >= intersectionThreshold) {
                if (slider.classList.contains('swinger-slider--show-next')) {
                  slider.classList.remove('swinger-slider--show-next');
                }
              } else if (!slider.classList.contains('swinger-slider--show-next')) {
                slider.classList.add('swinger-slider--show-next');
              }
              break;
          }
        });
      }
    }, 200));
  };
  const applyStops = (slider) => {
    window.clearTimeout(sliderApplyStopsTimers.get(slider));
    sliderApplyStopsTimers.set(slider, window.setTimeout(() => {
      const itemIntersectionRatios = itemIntersectionRatiosMap.get(slider) || [];

      if (itemIntersectionRatios.length) {
        itemIntersectionRatios.forEach((entry) => {
          if (entry.elem) {
            if (entry.intersectionRatio >= intersectionThreshold) {
              if (entry.elem.classList.contains('swinger-slider__item--stop')) {
                entry.elem.classList.remove('swinger-slider__item--stop');
              }
            } else if (!entry.elem.classList.contains('swinger-slider__item--stop')) {
              entry.elem.classList.add('swinger-slider__item--stop');
            }
          }
        });
      }
    }, 1000));
  };
  const renderDotNav = (slider) => {
    window.clearTimeout(sliderRenderDotNavTimers.get(slider));
    window.swinger.i18n()
      .then((i18n) => {
        sliderRenderDotNavTimers.set(slider, window.setTimeout(() => {
          const itemIntersectionRatios = itemIntersectionRatiosMap.get(slider) || [];
          const elem = window.swinger.$('.swinger-slider__dot-nav', slider)[0] || slider.appendChild(document.createElement('ul'));
          let html = '';
          let intersectionFound = false;

          elem.classList.add('swinger-slider__dot-nav');
          elem.setAttribute('role', 'list');
          elem.setAttribute('aria-label', 'Navigation');

          if (itemIntersectionRatios.length) {
            itemIntersectionRatios.forEach((entry, index) => {
              if (!document.getElementById(entry.elem.id)) {
                return;
              }

              if (entry.intersectionRatio >= intersectionThreshold) {
                intersectionFound = true;
              }

              html += `<li class="swinger-slider__dot-nav-item">
            <a href="#${entry.elem.id}" class="swinger-slider__dot-nav-button" ${entry.intersectionRatio >= intersectionThreshold ? ' aria-current="true"' : ''}>${i18n('ui.slider.dot-nav.button', { index: index + 1 })}</a>
          </li>`;
            });
          }

          if (intersectionFound) {
            elem.innerHTML = html;
          }
        }, 100));
      })
      .catch(console.info);
  };
  const preloadImages = (slider) => {
    window.clearTimeout(sliderPreloadImageTimers.get(slider));
    sliderPreloadImageTimers.set(slider, window.setTimeout(() => {
      const itemIntersectionRatios = itemIntersectionRatiosMap.get(slider) || [];

      if (itemIntersectionRatios.length) {
        itemIntersectionRatios.forEach((entry) => {
          const elem = entry.elem;
          const previousElem = elem.previousElementSibling;
          const nextElem = elem.nextElementSibling;

          if (entry.intersectionRatio >= intersectionThreshold) {
            if (previousElem && previousElem.querySelector('.swinger-image .swinger-image__lazy-load, .swinger-image img[loading="lazy"]')) {
              window.swinger.eventHub.trigger(previousElem.querySelector('.swinger-image'), 'swinger-image:load');
            }
            if (nextElem && nextElem.querySelector('.swinger-image .swinger-image__lazy-load, .swinger-image img[loading="lazy"]')) {
              window.swinger.eventHub.trigger(nextElem.querySelector('.swinger-image'), 'swinger-image:load');
            }
          }
        });
      }
    }, 100));
  };
  const goToIndex = (slider, index) => {
    slider.querySelector('.swinger-slider__items').style.scrollBehavior = 'auto';
    window.requestAnimationFrame(() => {
      const scrollToElems = slider.querySelectorAll('.swinger-slider__item:not(.swinger-slider__item--ignore)');
      const scrollToElem = scrollToElems[index];
      if (scrollToElem) {
        scrollToElem.scrollIntoView({
          block: 'nearest',
          inline: 'start',
        });
      }
      window.requestAnimationFrame(() => {
        slider.querySelector('.swinger-slider__items').style.scrollBehavior = '';
      });
    });
  };
  const imageObserver = (sliderItems) => {
    let observer = imageObserverMap.get(sliderItems);

    if (!observer) {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          const elem = entry.target;

          if (!entry.isIntersecting) {
            return;
          }

          window.swinger.eventHub.trigger(elem, 'swinger-image:load');
          observer.unobserve(elem);
        });
      }, {
        root: sliderItems,
        rootMargin: '0px 50% 0px 50%',
        scrollMargin: '0px 50% 0px 50%',
        threshold,
      });
      imageObserverMap.set(sliderItems, observer);
    }

    return observer;
  };
  const itemObserver = (slider) => {
    let observer = itemObserverMap.get(slider);

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const elem = entry.target;

          if (
            !elem
            || !elem.closest('.swinger-slider')
            || !elem.parentNode
          ) {
            return;
          }

          const slider = elem.closest('.swinger-slider');
          const itemIntersectionRatios = itemIntersectionRatiosMap.get(slider) || [];
          const parent = elem.parentNode;
          const children = Array.prototype.slice.call(parent.children).filter((child) => !child.matches('.swinger-slider__item--ignore'));
          const index = Array.prototype.indexOf.call(children, elem);

          itemIntersectionRatios[index] = {
            intersectionRatio: entry.intersectionRatio,
            elem: entry.target,
          };

          itemIntersectionRatiosMap.set(slider, itemIntersectionRatios);

          renderNav(slider);
          applyStops(slider);
          preloadImages(slider);

          if (slider.matches('.swinger-slider--has-dotnav')) {
            renderDotNav(slider);
          }
        });
      }, {
        root: slider,
        rootMargin: '100px 0px 100px 0px',
        threshold,
      });
      itemObserverMap.set(slider, observer);
    }

    return observer;
  };
  const stopAutoforward = (slider) => {
    const timer = sliderAutoforwardTimers.get(slider);
    window.clearInterval(timer);
  };
  const scroll = (slider, direction) => {
    const intersectionRatios = (itemIntersectionRatiosMap.get(slider) || []);

    if (direction === 'next') {
      intersectionRatios.reverse();
    }

    const firstFullyvisibleIndex = intersectionRatios
      .findIndex((entry) => entry.intersectionRatio > intersectionThreshold);
    let previousIndex = firstFullyvisibleIndex - 1;

    if (!intersectionRatios.length) {
      return;
    }

    if (firstFullyvisibleIndex === -1) {
      return;
    }

    if (!intersectionRatios[previousIndex]) {
      previousIndex = intersectionRatios.length - 1;
    }

    const scrollToElem = intersectionRatios[previousIndex].elem;

    if (direction === 'next') {
      intersectionRatios.reverse();
    }

    scrollToElem.scrollIntoView({
      block: 'nearest',
      // eslint-disable-next-line no-nested-ternary
      inline: direction === 'next' ? (previousIndex ? 'start' : 'end') : (previousIndex ? 'end' : 'start'),
    });
  };

  const initAutoscroll = (slider) => {
    if (window.matchMedia('(prefers-reduced-motion)').matches) { return; }
    if (slider.closest('.swinger-widget:not(.swinger-widget--rendered)')) {
      window.setTimeout(() => {
        initAutoscroll(slider);
      }, 200);
      return;
    }

    const timer = window.setInterval(() => {
      if (
        document.visibilityState !== 'visible'
        || slider.matches(':hover')
        || sliderIntersectionRatiosMap.get(slider) < 0.33
      ) {
        return;
      }
      scroll(slider, 'next');
    }, 8000);

    sliderAutoforwardTimers.set(slider, timer);
  };

  window.swinger.observer.initialize('.swinger-slider', (elem) => {
    sliderObserver.observe(elem);
    window.swinger.visibility.activeElement.track(elem);

    if (elem.matches('[data-start-index]')) {
      const index = Number(elem.getAttribute('data-start-index'));

      goToIndex(elem, index);
      window.setTimeout(() => {
        goToIndex(elem, index);
      }, 300);
    }
  }, false);

  window.swinger.eventHub.register('swinger-widget:rendered', '*', (e) => {
    const widget = window.swinger.eventHub.getTarget(e);
    const elem = window.swinger.$('.swinger-slider', widget)[0];

    if (!elem) {
      return;
    }

    renderNav(elem);
    applyStops(elem);
    preloadImages(elem);

    if (elem.matches('.swinger-slider--has-dotnav')) {
      renderDotNav(elem);
    }

    if (elem.matches('[data-start-index]')) {
      const index = Number(elem.getAttribute('data-start-index'));

      goToIndex(elem, index);
      window.setTimeout(() => {
        goToIndex(elem, index);
      }, 300);
    }
  });

  window.swinger.observer.initialize('.swinger-slider--is-autoforwarding', (elem) => {
    window.setTimeout(() => {
      initAutoscroll(elem);
    }, 3000);
  }, false);

  window.swinger.observer.initialize('.swinger-slider__item:not(.swinger-slider__item--ignore)', (elem) => {
    const slider = elem.closest('.swinger-slider');

    if (!slider) {
      return;
    }

    itemObserver(slider).observe(elem);
  }, false);

  window.swinger.observer.initialize('.swinger-slider__items .swinger-image', (elem) => {
    const sliderItems = elem.closest('.swinger-slider__items');

    if (!sliderItems) {
      return;
    }

    imageObserver(sliderItems).observe(elem);
  }, false);

  window.swinger.eventHub.register('click', '.swinger-slider__button--previous', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const slider = elem.closest('.swinger-slider');

    stopAutoforward(slider);
    scroll(slider, 'previous');
  });

  window.swinger.eventHub.register('click', '.swinger-slider__button--next', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const slider = elem.closest('.swinger-slider');

    stopAutoforward(slider);
    scroll(slider, 'next');
  });

  window.swinger.eventHub.register('click', '[href^="#swinger-slider-"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const link = elem.closest('a');
    const selector = link.getAttribute('href');
    const scrollToElem = window.swinger.$(selector)[0];
    const slider = scrollToElem.closest('.swinger-slider');

    if (scrollToElem) {
      stopAutoforward(slider);
      scrollToElem.scrollIntoView({
        block: 'nearest',
        inline: 'start',
      });
    }

    e.preventDefault();
  });

  document.addEventListener('keydown', (e) => {
    if (
      e.ctrlKey
      || e.altKey
      || e.metaKey
    ) {
      return;
    }

    switch (e.key) {
      default:
        return;

      case 'Left':
      case 'ArrowLeft':
      case 'Right':
      case 'ArrowRight':
        break;
    }

    const { activeElement } = document;

    if (activeElement.matches('a, input, select, textarea, [contenteditable]')) {
      return;
    }

    if (activeElement.matches('button, label') && !activeElement.closest('.swinger-slider')) {
      return;
    }

    let slider;

    if (activeElement.matches('button, label') && activeElement.closest('.swinger-slider')) {
      slider = activeElement.closest('.swinger-slider');
    } else {
      slider = window.swinger.visibility.activeElement.get('.swinger-slider');
    }

    if (!slider) {
      return;
    }

    slider.focus({ preventScroll: true });

    switch (e.key) {
      default:
        return;

      case 'Left':
      case 'ArrowLeft':
        stopAutoforward(slider);
        scroll(slider, 'previous');
        break;

      case 'Right':
      case 'ArrowRight':
        stopAutoforward(slider);
        scroll(slider, 'next');
        break;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  });
})();
